export const SET_DESKS = 'SET_DESKS'
export const SET_FLOORS = 'SET_FLOORS'
export const SET_ROOMS = 'SET_ROOMS'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_EMPTY_ASSETS = 'SET_EMPTY_ASSETS'
